import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { JSONEditorModule } from 'ngx-jsoneditor';

import { SharedModule } from '../shared/shared.module';
import { ConfigurationsDetailComponent } from './configurations-detail/configurations-detail.component';
import { ConfigurationsJsonComponent } from './configurations-json/configurations-json.component';
import { ConfigurationsTemplateIconComponent } from './configurations-template-icon/configurations-template-icon.component';
import {
  ConfigurationsTemplateOverlayComponent,
} from './configurations-template-overlay/configurations-template-overlay.component';
import { ConfigurationsTemplateTileComponent } from './configurations-template-tile/configurations-template-tile.component';
import { ConfigurationsComponent } from './configurations.component';
import { ConfigurationsRoutingModule } from './configurations.routing.module';
import { ConfigurationsService } from './shared/configurations.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MomentModule,
    SharedModule,
    HttpClientModule,
    ConfigurationsRoutingModule,
    JSONEditorModule
  ],
  providers: [ConfigurationsService],
  declarations: [
    ConfigurationsComponent,
    ConfigurationsDetailComponent,
    ConfigurationsJsonComponent,
    ConfigurationsTemplateIconComponent,
    ConfigurationsTemplateOverlayComponent,
    ConfigurationsTemplateTileComponent,
  ]
})
export class ConfigurationsModule {}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/configurations.module.ts